import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, QueryList, ViewChildren, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FusePerfectScrollbarDirective } from '@fuse/directives/fuse-perfect-scrollbar/fuse-perfect-scrollbar.directive';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { fuseAnimations } from '@fuse/animations';
///IDIOMAS
import { lang_certificar } from 'app/idiomas/i18n/certificar/certificar.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import {TranslateService} from '@ngx-translate/core';
import *  as $ from 'jquery';
import { MatDialog, MatDialogRef,MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalComponent } from 'app/main/pagina/modal/modal.component';
import { AdicionalesService } from 'app/main/wizard-cgo/services/adicionales.service';
import { WizardService } from 'app/main/wizard-cgo/services/wizard.service';
import * as backInter from 'app/auth/auth-data.model';
import Swal from 'sweetalert2';
import {MatSnackBar} from '@angular/material/snack-bar';
import { PreguntasComponent } from './preguntas/preguntas.component';

interface adverModal {
  tipo: number;
  mensaje: string;
  diccionario: string;
  confirma: boolean;
};


@Component({
    selector     : 'adicionales',
    templateUrl  : './adicional.component.html',
    styleUrls    : ['./adicional.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations   : fuseAnimations
})
export class AdicionalComponent implements OnInit {

  // Datos certificar vigente
  productoCertificar: backInter.prodCert;
  // IDIOMAS RECUPERADOS DE BD
  idiomas: backInter.getIdiomas;
  // preguntas adicionales de bd
  preguntasAdicionales: backInter.getAdicionales;

  //boolean sin preguntas adicionales
  sinAdicionales = false;

  //boolean cargando
  cargando = true;
  //boolean paso completo
  pasoCompleto = false;

  constructor(
    private adicionalesService: AdicionalesService,
    public dialog: MatDialog,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private wizardService: WizardService,
    private _snackBar: MatSnackBar,
  )
  {
    lang_certificar.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit() {
    // $(document).ready(function(){
    //   $(".finishBt").width($(".finishBt").parent().width());
    // });
    // $(window).resize(function(){
    //   $(".finishBt").width($(".finishBt").parent().width());
    // });

    this.obtieneCertificarActual();

  }

  private eventsSubject: Subject<any> = new Subject<any>();

  emitEventToChild() {
    this.eventsSubject.next(this.preguntasAdicionales);
  }

  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente
    this.adicionalesService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodCert[] = data.productosCertificar;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaCertificar;
            let idProducto = producto.idCertificar;
            if(fecha == parseInt(localStorage.getItem('fechaProducto')) && idProducto == localStorage.getItem('productoID')){
              this.productoCertificar = producto;
              throw BreakException;
            }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
      //obtiene el status del paso adicionales del certificar vigente
      this.adicionalesService.getStatusAdicionales(this.productoCertificar.fechaCertificar).subscribe( (data: backInter.getStatusIndiv) => {
        if(data.estatus === 3)
          this.pasoCompleto = true;

      });
      this.obtieneIdiomasGuardados();
      //obtiene las preguntas adicionales guardadas
      this.obtieneAdicionales();
      this.getStatusModal();

    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  getStatusModal(){
    let datos={
      fechaCertificar: this.productoCertificar.fechaCertificar,
      adicionales: 1
    };
    console.log(datos);
    this.wizardService.getStatusModal(datos).subscribe( (data: backInter.getStatusModal) => {
      if(data.estatus==1){
            this.modalInformativo('ADICIONALES');
      }
    });
  }

  updateStatusModal(){
    let datos={
      fechaCertificar: this.productoCertificar.idCertificar,
      adicionales: 2
    };
    // console.log(datos);
    this.wizardService.updateStatusModalMedir(datos).subscribe( (data: any) => {
      // console.log(data);
    });
  }

  obtieneIdiomasGuardados(){
    // this.adicionalesService.getIdiomas().subscribe( (data: backInter.getIdiomas) => {
    let fechaProducto: backInter.getIdiomaFechas = {fechaCertificar:this.productoCertificar.fechaCertificar};
    this.adicionalesService.getIdiomasProd(fechaProducto).subscribe( (data: backInter.getIdiomas) => {
      this.idiomas = data;
    });
  }

  obtieneAdicionales(actualizacion?:boolean){
    if(!actualizacion)
      this.cargando = true;

    this.adicionalesService.getAllAdicionales(this.productoCertificar.fechaCertificar).subscribe( (data: backInter.getAdicionales) => {
      this.preguntasAdicionales = data;
      console.log("adicionales obtenidos:");
      console.log(this.preguntasAdicionales);
      if(actualizacion){
        this.emitEventToChild();
      }
      else{
        this.cargando = false;
      }
    });
  }

  actualizarAdicionales(orden: boolean){
    if(orden){
      // this.preguntasAdicionales = null;
      this.obtieneAdicionales(true);
    }
  }

  actualizaStatusSinAdicionales(status:boolean){
    this.sinAdicionales = status;
  }



  completarPaso(){
    if(this.pasoCompleto){
      //this.aletaRestric('ADICIONALES.COMPLETADO',null,'warning');
      let textomessage = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.IDIOMAS.COMPLETADO';
      this.translateSrv.get(textomessage).subscribe((res: string) => { textomessage = res; });
      this._snackBar.open(textomessage, "Ok", {
        duration: 2000,
        horizontalPosition: "center",
        verticalPosition: "top",
        panelClass: ['background-red']
      });
    }
    else{
      if(this.preguntasAdicionales.adicionalesMostrar.length > 0 || this.sinAdicionales){
        this.aletaRestric('ADICIONALES.COMPLETAR',true);
      }
      else{
        this.aletaRestric('ADICIONALES.NADA',null,'warning');
      }
      //COLOCAR CONDICIONES Y VALIDACIONES PARA COMPLETAR EL PASO
    }

  }
  enviaOrdenWizard(){
    this.wizardService.puenteDatos("100"); //100 = actualiza los status de los steps
  }

  aletaRestric(mensaje:string, confirmar?:boolean, tipo?:string){

    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+mensaje;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    let rspNo = 'MODALES.ACCIONES.cancelar';
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(rspNo).subscribe((res: string) => { rspNo = res; });

    if(confirmar){
      Swal.fire({
        title: texto,
        icon: 'warning',
        showCancelButton: true,
reverseButtons: true,
        
        
        confirmButtonText: rspSi,
        cancelButtonText: rspNo
      }).then((result) => {
        if (result.value) {
          this.adicionalesService.guardaStatusAdicionales(this.productoCertificar.fechaCertificar).subscribe( (data: backInter.RespuestaGen) => {
            if(data.message == '214'){
              this.aletaRestric('ADICIONALES.'+data.message,null,'success');
              this.pasoCompleto = true;
              this.enviaOrdenWizard();
            };
          });
        }
      });
    }
    else{
      if(tipo == 'warning'){
        Swal.fire({
          icon: 'warning',
          title: texto,
          confirmButtonText: rspSi,
          confirmButtonColor: '#e40601'
        });
      }
      else if(tipo == 'success'){
        Swal.fire({
          icon: 'success',
          title: texto,
          confirmButtonText: rspSi,
          confirmButtonColor: '#e40601'
        });
      }
    }

  }

  modalInformativo(OPCIONMODAL:string){
    let texto = 'MODALES.MENSAJES.WIZARD.CERTIFICAR.'+OPCIONMODAL+'.INFORMATIVO';
    let botonModal = 'MODALES.ACCIONES.INFORMATIVO';
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
    this.translateSrv.get(botonModal).subscribe((res: string) => { botonModal = res; });
    Swal.fire({
      icon: 'info',
      title: texto,
      input: "checkbox",
      inputPlaceholder: botonModal,
      
      confirmButtonText: rspSi,
      allowOutsideClick: false
    }).then((result) => {
      if (result.value == 1){
        this.updateStatusModal();
      }
    });
  }

}
